import "core-js/modules/es.array.map.js";
import classnames from 'classnames';
import { Text } from "../../Text/Text/Text";
import styles from "./PriceBreakdown.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PriceBreakdown = function PriceBreakdown(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? 'Price Breakdown' : _ref$headline,
    _ref$totalLabel = _ref.totalLabel,
    totalLabel = _ref$totalLabel === void 0 ? '' : _ref$totalLabel,
    _ref$totalLabel2 = _ref.totalLabel2,
    totalLabel2 = _ref$totalLabel2 === void 0 ? '' : _ref$totalLabel2,
    _ref$totalPrice = _ref.totalPrice,
    totalPrice = _ref$totalPrice === void 0 ? '' : _ref$totalPrice,
    _ref$totalPrice2 = _ref.totalPrice2,
    totalPrice2 = _ref$totalPrice2 === void 0 ? '' : _ref$totalPrice2,
    _ref$totalPriceAriaLa = _ref.totalPriceAriaLabel,
    totalPriceAriaLabel = _ref$totalPriceAriaLa === void 0 ? '' : _ref$totalPriceAriaLa,
    _ref$totalPrice2AriaL = _ref.totalPrice2AriaLabel,
    totalPrice2AriaLabel = _ref$totalPrice2AriaL === void 0 ? '' : _ref$totalPrice2AriaL,
    _ref$totalStrikethrou = _ref.totalStrikethrough,
    totalStrikethrough = _ref$totalStrikethrou === void 0 ? false : _ref$totalStrikethrou,
    _ref$savingsLabel = _ref.savingsLabel,
    savingsLabel = _ref$savingsLabel === void 0 ? '' : _ref$savingsLabel,
    _ref$marketingMessage = _ref.marketingMessage,
    marketingMessage = _ref$marketingMessage === void 0 ? '' : _ref$marketingMessage,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? 'default' : _ref$version,
    simplifiedCards = _ref.simplifiedCards;
  var detailedVersion = version === 'V4' || version === 'V5';
  var totalPriceInfo = {
    label: totalLabel,
    label2: totalLabel2,
    price: totalPrice,
    price2: totalPrice2,
    priceAriaLabel: totalPriceAriaLabel,
    price2AriaLabel: totalPrice2AriaLabel,
    strikethrough: totalStrikethrough
  };
  var renderPriceInfo = function renderPriceInfo(item) {
    return detailedVersion ? /*#__PURE__*/_jsxs("div", {
      className: styles.pricing,
      children: [/*#__PURE__*/_jsx(Text, {
        typog: item.promo ? 'subhead4' : 'bodycopy',
        className: classnames({
          [styles.strikethrough]: item.strikethrough,
          [styles.promo]: item.promo
        }),
        textElement: "span",
        "aria-label": item.priceAriaLabel || undefined,
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [!item.priceAriaLabel && item.price, item.priceAriaLabel && /*#__PURE__*/_jsx("span", {
            "aria-hidden": "true",
            children: item.price
          })]
        })
      }), item.price2 && /*#__PURE__*/_jsxs(Text, {
        typog: item.promo ? 'subhead4' : 'subhead2',
        className: styles.price2,
        textElement: "span",
        "aria-label": item.price2AriaLabel || undefined,
        children: [!item.price2AriaLabel && item.price2, item.price2AriaLabel && /*#__PURE__*/_jsx("span", {
          "aria-hidden": "true",
          children: item.price2
        })]
      })]
    }) : /*#__PURE__*/_jsx(Text, {
      typog: item.promo ? 'subhead4' : 'bodycopy',
      className: classnames({
        [styles.strikethrough]: item.strikethrough,
        [styles.promo]: item.promo
      }),
      textElement: "span",
      "aria-label": item.priceAriaLabel || undefined,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [!item.priceAriaLabel && item.price, item.priceAriaLabel && /*#__PURE__*/_jsx("span", {
          "aria-hidden": "true",
          children: item.price
        })]
      })
    });
  };
  var renderItems = function renderItems() {
    if (!items) {
      return null;
    }
    return items.map(function (item, index) {
      return item.label && (item.price || item.price2) && /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.item, detailedVersion && styles.itemV4),
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Text, {
            typog: item.promo ? 'subhead4' : 'bodycopy',
            textElement: "span",
            className: classnames({
              [styles.label]: true,
              [styles.promo]: item.promo
            }),
            children: item.label
          }), item.label2 && /*#__PURE__*/_jsx(Text, {
            typog: 'bodycopySmall',
            textElement: "span",
            className: classnames({
              [styles.label]: true,
              [styles.promo]: item.promo
            }),
            children: item.label2
          })]
        }), renderPriceInfo(item)]
      }, "price-item-".concat(index));
    });
  };
  var renderSavingsLabel = function renderSavingsLabel() {
    return detailedVersion ? /*#__PURE__*/_jsx(Text, {
      className: styles.savingsV4,
      typog: "subhead3",
      children: savingsLabel
    }) : /*#__PURE__*/_jsx(Text, {
      className: styles.savings,
      typog: "bodycopySmall",
      children: savingsLabel
    });
  };
  var renderMarketingMessage = function renderMarketingMessage(marketingMessage) {
    var typog = version === 'V5' ? 'bodycopySmall' : 'subhead4';
    return /*#__PURE__*/_jsx(Text, {
      typog: typog,
      className: classnames(styles.marketingMessage, detailedVersion ? !totalLabel || !totalPrice ? styles.promoV4NoTotal : styles.promoV4 : styles.promo),
      children: marketingMessage
    });
  };
  if (simplifiedCards) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.wrapperV6,
      children: [detailedVersion && headline && /*#__PURE__*/_jsx(Text, {
        className: styles.priceBreakdownHeader,
        typog: 'subhead3',
        children: headline
      }), renderItems(), detailedVersion && totalLabel && (totalPrice || totalPrice2) && /*#__PURE__*/_jsx("div", {
        className: styles.horizontalRule
      }), /*#__PURE__*/_jsxs("div", {
        className: classnames({
          [styles.total]: true,
          [styles.totalV4]: detailedVersion && !totalLabel || !totalPrice
        }),
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Text, {
            typog: detailedVersion ? 'subhead3' : 'subhead4',
            children: totalLabel
          }), totalLabel2 && /*#__PURE__*/_jsx(Text, {
            typog: "bodycopySmall",
            children: totalLabel2
          })]
        }), renderPriceInfo(totalPriceInfo)]
      }), renderSavingsLabel(), marketingMessage && renderMarketingMessage(marketingMessage)]
    });
  } else {
    return /*#__PURE__*/_jsxs("div", {
      className: detailedVersion ? styles.wrapperV4 : styles.wrapper,
      children: [detailedVersion && headline && /*#__PURE__*/_jsx(Text, {
        className: styles.priceBreakdownHeader,
        typog: 'subhead3',
        children: headline
      }), renderItems(), detailedVersion && totalLabel && (totalPrice || totalPrice2) && /*#__PURE__*/_jsx("div", {
        className: styles.horizontalRule
      }), /*#__PURE__*/_jsxs("div", {
        className: classnames({
          [styles.total]: true,
          [styles.totalV4]: detailedVersion && !totalLabel || !totalPrice
        }),
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Text, {
            typog: detailedVersion ? 'subhead3' : 'subhead4',
            children: totalLabel
          }), totalLabel2 && /*#__PURE__*/_jsx(Text, {
            typog: "bodycopySmall",
            children: totalLabel2
          })]
        }), renderPriceInfo(totalPriceInfo)]
      }), renderSavingsLabel(), marketingMessage && renderMarketingMessage(marketingMessage)]
    });
  }
};